var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "landing-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing_final_hover-on-after",
    transform: "translate(-295.000000, -2800.000000)",
    stroke: "#FF8E46",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.668354,2814.66669 L327.643827,2817.02795 C328.954148,2817.3723 328.954148,2817.92237 327.643827,2818.28461 L318.668354,2820.63245 C317.962659,2820.86232 317.321362,2821.25586 316.797681,2821.78133 C316.273553,2822.3068 315.881798,2822.94944 315.654169,2823.65558 L313.301853,2832.65789 C312.957502,2833.97268 312.407436,2833.97268 312.058613,2832.65789 L309.710769,2823.65558 C309.484481,2822.94854 309.093174,2822.30546 308.569046,2821.77999 C308.044917,2821.25407 307.403173,2820.86097 306.696584,2820.63245 L297.725583,2818.28461 C296.41079,2817.93578 296.41079,2817.39019 297.725583,2817.02795 L306.696584,2814.66669 C307.40362,2814.44085 308.046259,2814.04909 308.570387,2813.52363 C309.094963,2812.9986 309.485823,2812.35552 309.710769,2811.64803 L312.058613,2802.6502 C312.407436,2801.30857 312.95303,2801.30857 313.301853,2802.6502 L315.654169,2811.64803 C315.880009,2812.35507 316.271317,2812.99771 316.795445,2813.52273 C317.32002,2814.04775 317.961765,2814.43996 318.668354,2814.66669 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star2.a066bf898f7c39564c8261e1be2e02eb.svg";
export { ForwardRef as ReactComponent };